// Reducer that changes the state based on the action

import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoading: false,
    authToken: null,
    user: null,
    isSupervisor: null,
    error: null,
    success: false,
    isTrialExpired: false,
    isSubscriptionExpired: false,
    resetMode: false,
    ssoLoading: false,
    // ssoLoading: true,
  },
  reducers: {
    startLogin: (state, action) => {
      state.isLoading = true;
      state.success = false;
      state.error = null;
    },
    setSSOLoading: (state, action) => {
      state.ssoLoading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
      state.isLoading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAuthToken: (state, action) => {
      state.authToken = action.payload;
      state.isLoading = false;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isSupervisor = action.payload?.is_supervisor;
      state.isLoading = false;
    },
    setUserIsSupervisor: (state, action) => {
      state.isSupervisor = action.payload;
    },
    setIsTrialExpired: (state, action) => {
      state.isTrialExpired = action.payload;
    },
    setIsSubscriptionExpired: (state, action) => {
      state.isSubscriptionExpired = action.payload;
    },
    logoutUser: (state, action) => {
      state.isLoading = false;
      state.user = null;
      state.authToken = null;
      state.error = null;
      state.success = false;
      state.isSupervisor = null;
    },
    setResetMode: (state, action) => {
      state.resetMode = action.payload;
    },
  },
});

export const {
  startLogin,
  setSuccess,
  setError,
  setAuthToken,
  setUser,
  setIsTrialExpired,
  setIsSubscriptionExpired,
  setUserIsSupervisor,
  logoutUser,
  setResetMode,
  setSSOLoading
} = authSlice.actions;

export const useAuhToken = () => useSelector((state) => state.Auth.authToken);
export const useResetMode = () => useSelector((state) => state.Auth.resetMode);
export const useSSOLoading = () => useSelector((state) => state.Auth.ssoLoading);
export const useUser = () => useSelector((state) => state.Auth.user);
export const useIsSupervisor = () => useSelector((state) => state.Auth.isSupervisor);
export const useIsTrialExpired = () => useSelector((state) => state.Auth.isTrialExpired);
export const useIsSubscriptionExpired = () => useSelector((state) => state.Auth.isSubscriptionExpired);
export const useIsLoading = () => useSelector((state) => state.Auth.isLoading);
export const useSuccess = () => useSelector((state) => state.Auth.success);
export const useError = () => useSelector((state) => state.Auth.error);

export default authSlice.reducer;
